import { GoogleAnalytics, MetricIndex } from "./GoogleAnalytics";

const ga = new GoogleAnalytics();

export default class FileUtils {

  public static downloadXlsx(body: ReadableStream, fileName: string) {
    FileUtils.processReadableStreamReader(body, FileUtils.xlsx, fileName);
  }

  public static downloadPdf(body: ReadableStream, fileName: string) {
    FileUtils.processReadableStreamReader(body, FileUtils.pdf, fileName);
  }

  private static MediaType = {
    PDF: 'application/pdf',
    XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  }

  private static processReadableStreamReader(body: ReadableStream, cb: (result:Uint8Array, fileName:string) => any, fileName: string) {
    const reader = body.getReader();
    let result = new Uint8Array([]);

    reader.read().then(function processText({ done, value }): any {
      if (done) {
        cb(result, fileName);
        return;
      }
      result = new Uint8Array([...result, ...value]);
      return reader.read().then(processText);
    });
  }

  private static xlsx = (value: Uint8Array, fileName: string = 'planilha.xlsx') => {
    FileUtils.download(value, fileName, FileUtils.MediaType.XLSX);
  }

  private static pdf = (value: Uint8Array, fileName: string = 'documento.pdf') => {
    FileUtils.download(value, fileName, FileUtils.MediaType.PDF);
  }

  private static download = (value: Uint8Array, fileName: string, mediaType: string)  => {
    const blob = new Blob([value], { type: mediaType });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    const metricName = 'metric'+MetricIndex.DOWNLOAD;
    ga.fireEventTracking((FileUtils.MediaType.PDF===mediaType ? 'pdf':'xlsx'), 'download', fileName, false, metricName);
    link.click();   
  }

}


// WEBPACK FOOTER //
// ./src/services/FileUtils.tsx